/** @jsxImportSource @emotion/react */

import React, { useState } from 'react';
import { v4 as uuid4 } from 'uuid';
import styled from 'styled-components';
import Scroll from '@component/common/scroll';
import * as size from '@constant/size';
import * as color from '@constant/color';
import { useTypedDispatch } from '@hook/common/useStore';
import { useMyShelvesQuery } from '@hook/moashelf/useApi';
import ShelfItem from '@component/moashelf/newsletter/shelves/shelf-item';
import { isMobile } from 'react-device-detect';
import { removeEmailDomain } from '@util/string';
import { IShelfData } from '@datatype/moashelf/api-type';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import TextBlock from '@component/common/block/text-block';
import { IMoashelfMenu } from '@datatype/moashelf/type';

interface IProps {
  mode: IMoashelfMenu['shelf'];
}

const Wrapper = styled.div`
  height: 100%;
`;

const ShelfItemsContainer = styled.div`
  position: relative;
  width: 100%;
  // margin: ${size.MARGIN_2} auto 0 auto;
  //border: ${size.BORDER_WIDTH_1} solid ${color.GRAY_3};
  border-radius: ${size.BORDER_RADIUS_3};
`;

const TEXT_DESIGN = {
  text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'medium' : 'medium', color: color.BLACK_2, bold: false },
  box: { alignX: 'left', margin: `${size.MARGIN_2} 0 0 ${size.MARGIN_2}` },
} as const;

const Shelves: React.FC<IProps> = ({ mode }) => {
  const dispatch = useTypedDispatch();
  const query = useMyShelvesQuery(mode, 1, 50);
  const shelves = (query.data?.data || []) as IShelfData[];

  let notificationText;

  switch (mode) {
    case 'shelf-all':
      notificationText = '받은 뉴스레터가 없습니다. 🙂';
      break;
    case 'shelf-bookmark':
      notificationText = '즐겨찾기한 뉴스레터가 없습니다. 🙂';
      break;
    case 'shelf-trash':
      notificationText = '삭제한 뉴스레터가 없습니다. 🙂';
      break;
    case 'shelf-unread':
      notificationText = '안읽은 뉴스레터가 없습니다. 🙂';
      break;
    default:
      notificationText = '';
      break;
  }

  const ShelfItems = shelves
    .filter((shelf) => {
      if (mode === 'shelf-all') return !shelf.trashedAt;
      if (mode === 'shelf-trash') return !!shelf.trashedAt;
      return true;
    })
    .map((shelf) => {
      return (
        <ShelfItem
          key={uuid4()}
          shelfKey={shelf.key}
          title={shelf.article.title}
          isBookmark={shelf.isBookmark}
          readAt={shelf.readAt}
          trashedAt={shelf.trashedAt ?? ''}
          publishedAt={shelf.article.publishedAt}
          provider={shelf.article.provider.name || removeEmailDomain(shelf.article.provider.email)}
        />
      );
    });

  return (
    <Wrapper>
      {/* TODO: Naivigator 높이만큼 빼기 */}
      <Scroll direction='y' height={isMobile ? '100%' : '100%'}>
        {ShelfItems.length > 0 ? (
          <ShelfItemsContainer>{ShelfItems}</ShelfItemsContainer>
        ) : (
          <TextBlock text={notificationText} design={TEXT_DESIGN} />
        )}
      </Scroll>
    </Wrapper>
  );
};

export default Shelves;
